import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import LiveProcessStatusBadge from 'domains/merchant-product-variant/atoms/live-process-status-badge'
import PutAwayStatusBadge from 'domains/merchant-product-variant/atoms/put-away-status-badge'
import PhotoUploadStatusBadge from 'domains/merchant-product/atoms/photo-upload-status-badge'
import { LIVE_PROCESS_STATUS } from 'domains/merchant-product-variant/constants'
import React from 'react'
import TimeUtil from 'utils/time-util'

/**
 * Merchant Product Variant Table Columns
 */
const merchantProductVariantTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick
}) => {
  // eslint-disable-next-line react/prop-types
  const LiveProcessStatusFilter = ({ column }) => {
    const options = Object.keys(LIVE_PROCESS_STATUS).map((key) => (
      {
        label : LIVE_PROCESS_STATUS[key],
        value : LIVE_PROCESS_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const MerchantTypeCell      = (row) => <MerchantBadge merchant_type={ row.cell.value } />
  const PutAwayStatusCell     = (row) => <PutAwayStatusBadge putAwayStatus={ row.cell.value } />
  const PhotoUploadStatusCell = (row) => <PhotoUploadStatusBadge photoUploadStatus={ row.cell.value } />
  const LiveProcessStatusCell = (row) => <LiveProcessStatusBadge liveProcessStatus={ row.cell.value } />
  const DateCell              = (row) => TimeUtil.format(row.cell.value)

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      color={ buttonColour }
      onClick={ onButtonClick }
      text={ buttonText }
    />
  )

  return (
    [
      {
        Header  : 'Merchant',
        columns : [
          {
            Header   : 'Name',
            id       : 'merchant_name',
            accessor : 'merchant_product.merchant.name'
          },
          {
            Header   : 'Code',
            id       : 'merchant_code',
            accessor : 'merchant_product.merchant.code'
          },
          {
            Header         : 'Type',
            accessor       : 'merchant_product.merchant.merchant_type',
            id             : 'merchant_type',
            disableFilters : true,
            Cell           : MerchantTypeCell
          }
        ]
      },
      {
        Header  : 'Product Variant',
        columns : [
          {
            Header         : 'Id',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header   : <>Inventory <br/>SKU</>,
            accessor : 'inventory_sku'
          },
          {
            Header         : 'Name',
            id             : 'product_name',
            accessor       : 'merchant_product.name',
            disableFilters : true
          },
          {
            Header         : 'Category',
            id             : 'product_category',
            accessor       : 'merchant_product.category',
            disableFilters : true
          },
          {
            Header         : 'Size',
            accessor       : 'size',
            disableFilters : true
          },
          {
            Header         : <>Photo Upload<br/> Status</>,
            id             : 'photo_upload_status',
            accessor       : 'merchant_product.photo_upload_status',
            disableFilters : true,
            Cell           : PhotoUploadStatusCell
          },
          {
            Header         : <>Put Away<br/> Status</>,
            accessor       : 'put_away_status',
            disableFilters : true,
            Cell           : PutAwayStatusCell
          },
          {
            Header   : <>Live Process<br/> Status</>,
            accessor : 'live_process_status',
            Filter   : LiveProcessStatusFilter,
            Cell     : LiveProcessStatusCell
          },
          {
            Header         : <>Live<br/>Date</>,
            accessor       : 'live_date',
            disableFilters : true,
            Cell           : DateCell
          }
        ]
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default merchantProductVariantTableColumns
